import { Dialog } from '../reducers/dialog';

export type FnDialogOpen = (dialog: Dialog) => void;

export enum DialogTypes {
  DEFAULT = 'DEFAULT',
  DISMISS_NOTIFICATION = 'DISMISS_NOTIFICATION',
}
